var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "create__new",
      class: _vm.$store.state.tariff.style,
      attrs: { id: "popup_get_resume" }
    },
    [
      _c("div", { staticClass: "popup_block" }, [
        _c("div", {
          staticClass: "back_to_icon",
          on: {
            click: function($event) {
              return _vm.backPayment()
            }
          }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "close",
          on: {
            click: function($event) {
              return _vm.$store.commit("isOpenConfirmModal", false)
            }
          }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "title_plane",
          domProps: {
            innerHTML: _vm._s(_vm.$store.getters.t("there__are__cv"))
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "buttons--center" }, [
          _c(
            "button",
            { staticClass: "btn-ok", on: { click: _vm.createCvPage } },
            [_vm._v(_vm._s(_vm.$store.getters.t("new__cv")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn-ok", on: { click: _vm.goToProfile } },
            [_vm._v(_vm._s(_vm.$store.getters.t("go__cvs")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c219520a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c219520a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/ConfirmModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c219520a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/ConfirmModal.vue
// module chunks = 0